import * as React from 'react'

import { apiRequest } from './Request'
import { handleErrResponse } from '.'
import { renderCenteredLoading } from '../ui/Spinner/helpers'

export interface ChildrenOptions {
  status: number
  loading: boolean
  wasFetched: boolean
  forceRefresh: (page?: number) => void
}

export interface FetchProps {
  url: string
  showLoading?: boolean
  showLoadingAfter?: number
  children: (item: {}, options: ChildrenOptions) => React.ReactNode
}

export default class Fetch extends React.Component<
  FetchProps,
  {
    data: any
    status: number
    loading: boolean
    isFetching: boolean
    wasFetched: boolean
  }
> {
  state = {
    data: {},
    status: 0,
    loading: false,
    isFetching: false,
    wasFetched: false,
  }
  static defaultProps = {
    showLoading: true,
    showLoadingAfter: 300,
  }
  timer = 0
  interval: number

  forceRefresh = async () => {
    await this.fetch(this.props.url)
  }
  fetch = async (url: string) => {
    this.setState(state => {
      return { ...state, isFetching: true }
    })
    try {
      const response = await apiRequest.get(url)
      this.setState(state => {
        return {
          ...state,
          data: response.data,
          status: response.status,
          isFetching: false,
          wasFetched: true,
        }
      })
    } catch (err) {
      handleErrResponse(err)

      this.setState(state => {
        return {
          ...state,
          data: err.response.data,
          status: err.response.status,
          isFetching: false,
          wasFetched: true,
        }
      })
    }
  }
  startTimer = () => {
    const step = 10
    this.interval = setInterval(() => {
      this.timer = this.timer + step
      if (
        (this.props.showLoadingAfter &&
          this.props.showLoadingAfter < this.timer) ||
        this.state.wasFetched
      ) {
        clearInterval(this.interval)

        this.setState(state => {
          return { ...state, loading: false }
        })
      }
    }, step)
  }
  async componentDidMount() {
    this.timer = 0
    this.startTimer()
    await this.fetch(this.props.url)
  }
  async componentDidUpdate(nextProps) {
    if (this.props.url !== nextProps.url) {
      await this.fetch(this.props.url)
    }
  }
  componentWillUnmount() {
    this.timer = 0
    clearInterval(this.interval)
  }
  render() {
    const options: ChildrenOptions = {
      status: this.state.status,
      loading: this.state.loading,
      wasFetched: this.state.wasFetched,
      forceRefresh: this.forceRefresh,
    }
    if (this.state.wasFetched) {
      return this.props.children(this.state.data, options)
    }
    if (this.state.isFetching && this.state.loading) {
      return renderCenteredLoading()
    }

    return null
  }
}
